import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import { BRAND_DEFAULT } from '../tokens/color.js';
import { tokensCss } from '../tokens/css.js';
import { useColorMode } from './color-mode.js';
import { ColorModeProvider } from './color-mode-provider.js';
import { createSprocketTheme } from './create-theme.js';
const TOKENS_CSS = tokensCss();
function BrandedTheme({ brand, children }) {
    const { mode } = useColorMode();
    const theme = useMemo(() => createSprocketTheme(brand, mode), [brand, mode]);
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(GlobalStyles, { styles: TOKENS_CSS }), children] }));
}
/**
 * The one provider an app mounts: colour mode (persisted, OS-tracking) → the MUI theme
 * built from the tokens and the tenant's brand → CssBaseline → the token custom
 * properties. Fonts (Geist, Geist Mono) are imported here, once, and nowhere else.
 */
export function SprocketThemeProvider({ brand = BRAND_DEFAULT, initialPreference, children, }) {
    return (_jsx(ColorModeProvider, { ...(initialPreference ? { initialPreference } : {}), children: _jsx(BrandedTheme, { brand: brand, children: children }) }));
}
//# sourceMappingURL=sprocket-theme-provider.js.map